"use client";
import { useGigyaAccountInfo } from "@/helpers/gigyaCentralSsoHook";
import {
  useAppDispatch,
  useAppSelector,
  useEffect,
  useRef,
  useState,
} from "@/utils/hooks/reactUseCustomHooks";
import { getRecipeListAction } from "@/utils/redux/recipes/addtolistSlice/actions";
import { FAVOURITES } from "@/utils/constant";
import {
  setFavourites,
  setModifiedRecipeList,
  setOriginalRecipeList,
  setRecipeList,
} from "@/utils/redux/recipes/addtolistSlice";
import {
  fetchDataFromAlgoliaById,
  getEnrichList,
  getPayloadForAlgolia,
} from "@/services/algolia";
import { usePathname } from "next/navigation";
import { setAllMealPlanDataFunc } from "@/templates/mealPlan/commonFunctions/mealPlanUtils";

const useRecipes = () => {
  const [loader, setLoder] = useState(false);
  const { uid: Uid } = useAppSelector((state) => state.gigyaslice);
  const {
    recipeList: recipeListData,
    originalRecipeList,
    modifiedRecipeList: recipeList,
    favourite,
  } = useAppSelector((state) => state.RecipeToList);
  const gigyaToken = useGigyaAccountInfo();
  const dispatch = useAppDispatch();

  const hasFetched = useRef(false);
  const hasMealPlanFetched = useRef(false);

  const pathname = usePathname();
  useEffect(() => {
    if (!Uid || hasFetched.current) return;
    const fetchData = async () => {
      try {
        setLoder(true);
        const { idToken: token } = await gigyaToken();
        // Check for cached data
        // const [cachedFavourites, cachedRecipeList] = await Promise.all([
        //   getCache(`favourites:${Uid}`),
        //   getCache(`recipe_list:${Uid}`),
        // ]);

        const listPromise =
          // cachedRecipeList
          //   ? Promise.resolve({ payload: cachedRecipeList })
          // :
          dispatch(getRecipeListAction({ token }));

        const [listResult] = await Promise.all([listPromise]);

        // if (!cachedRecipeList) {

        const favouritesList =
          listResult.payload.data?.find(
            (list: { list_name: string }) => list.list_name === FAVOURITES
          ) || [];

        const recipeListIDs =
          listResult.payload.data?.filter(
            (list: { list_name: string }) => list.list_name !== FAVOURITES
          ) || [];

        // await setCache(`recipe_list:${Uid}`, recipeLists);
        // if (favouritesList) {
        //   await setCache(`favourites:${Uid}`, favouritesList);
        // }

        dispatch(setFavourites(favouritesList));
        dispatch(setRecipeList(recipeListIDs));
        if (!hasMealPlanFetched.current && pathname != "/recipes/meal-plan" ) {
          hasMealPlanFetched.current = true;
          await setAllMealPlanDataFunc(Uid, dispatch, token);
        }
        // Execute only if the page is myrecipelist or originalRecipeList is empty or modified recipelist is empty.
        if (
          pathname == "/recipes/my-recipe-lists" ||
          !originalRecipeList.length ||
          !recipeList.length
        ) {
          const enrichedList = await fetchAndSet(listResult.payload.data);
          const recipeLists =
            enrichedList?.filter(
              (list: { list_name: string }) => list.list_name !== FAVOURITES
            ) || [];
          dispatch(setModifiedRecipeList(recipeLists));
          dispatch(setOriginalRecipeList(recipeLists));
        }

        // } else {
        //   dispatch(setRecipeList(recipeListData));
        //   dispatch(setFavourites(cachedFavourites));
        //   dispatch(setModifiedRecipeList(cachedRecipeList));
        //   dispatch(setOriginalRecipeList(cachedRecipeList));
        // }

        // Handle 401s
        [listResult].forEach((result) => {
          if (result?.payload?.status === 401) {
            console.log("Session TimeOut");
          }
        });
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoder(false);
        hasFetched.current = true;
      }
    };
    void fetchData();
  }, [Uid]);

  return {
    loader,
    recipeListData,
    originalRecipeList,
    recipeList,
    favourite,
  };
};

export default useRecipes;

const fetchAndSet = async (recipeListData: any) => {
  const payload = getPayloadForAlgolia(recipeListData);
  try {
    const data: any = await fetchDataFromAlgoliaById(payload);
    const enrichedList = getEnrichList(recipeListData, data);
    return enrichedList;
  } catch (error) {
    console.error("Error fetching Algolia data:", error);
    return null;
  }
};
